// The confluence-previews WRM plugin is already loaded at the View Page shell
// level, so the jQuery delegation listener is active for anchors with the
// legacy `previewAttachmentLink` className and `data-linked-resource-*`
// attributes. We do not need to require the plugin ourselves.
//
// The only shared piece needed by the table is the ARI → bare-id transform
// the legacy previewer expects in its href.

// Strip ARI wrapper → bare numeric id the legacy previewer expects.
export const toPreviewAttachmentId = (attachmentId: string): string => {
	if (!attachmentId) {
		return attachmentId;
	}
	const tail = attachmentId.includes('/')
		? attachmentId.slice(attachmentId.lastIndexOf('/') + 1)
		: attachmentId;
	return /^att\d+$/.test(tail) ? tail.slice(3) : tail;
};

export type LegacyPreviewTarget = {
	pageId: string;
	attachmentId: string;
	fileName: string;
};

export const buildLegacyPreviewParam = ({
	pageId,
	attachmentId,
	fileName,
}: LegacyPreviewTarget): string => `/${pageId}/${toPreviewAttachmentId(attachmentId)}/${fileName}`;
